import Vue from 'vue'
import Vuex from 'vuex'
import router from "@/router";
import getAnalyzes from "@/api/analyzes/getAnalyzes";
import getAnalyzeDocument from "@/api/analyzes/getAnalyzeDocument";
import getAnalyzesChartList from "@/api/analyzes/getAnalyzesChartList";
import getAnalyzesChart from "@/api/analyzes/getAnalyzesChart";

Vue.use(Vuex)


const state = {
    analyzesList: [],
    analyzesChartList: [],
    chartData: [],
    selectedAnalyzeItem:null
}
const mutations = {
    SET_ANALYZES(state, payload) {
        state.analyzesList = payload;
    },
    SET_ANALYZES_CHART_LIST(state, payload) {
        state.analyzesChartList = payload;
    },
    SET_CHART_DATA(state, payload) {
        state.chartData = payload;
    },
    SET_SELECTED_ANALYZE_ITEM(state, payload) {
        state.selectedAnalyzeItem = payload;
    }
}

const actions = {
    getAnalyzesList({commit, dispatch}, payload) {
        return getAnalyzes(payload).then((response) => {
            commit('SET_ANALYZES', response)
        })
    },
    getAnalyzeDocument({commit}, payload) {
        return getAnalyzeDocument(payload.id)
    },
    getAnalyzesChartList({commit}) {
        return getAnalyzesChartList().then((response) => {
            commit('SET_ANALYZES_CHART_LIST', response)
        })
    },
    getAnalyzesChart({commit}, payload) {
        return getAnalyzesChart(payload).then((response) => {
            if (response.length === 0) router.push({name: 'profile.analyzes.detail'})
            commit('SET_CHART_DATA', response)
            commit('SET_SELECTED_ANALYZE_ITEM', payload)
        })
    }
}

export default {
    state,
    mutations,
    actions
}